import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`This project was built with `}<span className="contact-link"><a href="https://www.gatsbyjs.org/">{`GatsbyJS`}</a></span>{`, which I personally think is `}<strong parentName="p"><em parentName="strong">{`pretty cool!`}</em></strong></p>
    </blockquote>
    <p>{`Here you could add details about yourself, your business, or embed a video! ⬇️`}</p>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/dx9Tm6Zspok?si=ZN6XmzeqH4ma_BBq" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      